export default () => {
    document.body.classList.add('no-scroll');

    const loaderWrapper = document.querySelector('[data-loader-wrapper]');
    const cover = document.querySelector('[data-cover]');
    const loader = document.querySelector('[data-loader]');
    const mark = document.querySelector('[data-loader-mark]');
    const whiteSlice01 = document.querySelector('[data-white-slice-01]');
    const whiteSlice02 = document.querySelector('[data-white-slice-02]');
    const graySlice01 = document.querySelector('[data-gray-slice-01]');
    const graySlice02 = document.querySelector('[data-gray-slice-02]');
    let loadingTextOnce;
    let split;

    const getRandom = arr => {
        return arr[~~(Math.random() * arr.length)];
    };

    const loadingTexts = loaderWrapper.querySelectorAll('[data-transition-text]');

    if (loadingTexts.length > 0) {
        loadingTextOnce = getRandom(loadingTexts);

        split = new SplitText(loadingTextOnce, {
            type: 'chars, words, lines',
            linesClass: '-mt-2 py-1 pr-1 overflow-hidden'
        });

        loadingTextOnce.classList.remove('hidden');
    }

    const finish = () => {
        if (loadingTexts.length > 0) {
            loadingTextOnce.classList.add('hidden');
            split.revert();
        }
    };

    const initialLoad = gsap.timeline({
        onComplete: () => {
            document.body.classList.remove('no-scroll');
            finish();
        }
    });

    initialLoad
        .set(graySlice01, { yPercent: -104 })
        .set(graySlice02, { yPercent: -104 })
        .addLabel('load')
        .set(cover, { autoAlpha: 0 })
        .fromTo(mark, { autoAlpha: 0 }, { duration: 0.3, autoAlpha: 1 })
        .fromTo(loader, { xPercent: -104 }, { duration: 0.6, xPercent: 0, ease: 'circ.inOut' }, 'load')

        .to(loader, { duration: 0.4, xPercent: 104, ease: 'circ.inOut' }, '>0.1')
        .addLabel('start');

    if (loadingTexts.length > 0) {
        initialLoad
            .fromTo(
                split.chars,
                {
                    opacity: 0,
                    xPercent: -20
                },
                {
                    duration: 0.25,
                    opacity: 1,
                    xPercent: 0,
                    stagger: 0.005,
                    ease: 'circ.inOut'
                },
                'load+=0.4'
            )

        .to(
            split.chars,
            {
                duration: 0.25,
                opacity: 0,
                stagger: 0.005,
                ease: 'circ.inOut'
            },
            'start'
        );
    }

    initialLoad
        .to(whiteSlice01, { duration: 0.4, yPercent: 104, ease: 'circ.inOut' }, 'start-=0.2')
        .to(whiteSlice02, { duration: 0.5, yPercent: -104, ease: 'circ.inOut' }, 'start')
        .to(mark, { duration: 0.3, autoAlpha: 0 }, 'start')
        .set(loaderWrapper, { autoAlpha: 0 });
};
